import * as t from 'io-ts';
import {isBoolean, pickBy} from 'lodash';

import {makeApiType, makeDefaultValueType} from './apiTypes';

/*
 * Runtime type.
 */

const RLaunchdarklyConfigDirty = t.readonly(
  t.type({
    clientSideId: t.string,
    isEnabled: t.boolean,
    userHash: t.union([t.undefined, t.string]),
    flags: t.union([t.undefined, t.dictionary(t.string, makeDefaultValueType(t.boolean, false))]),
  }),
);

/*
 * Type.
 */

export interface LaunchdarklyConfigModel extends t.TypeOf<typeof RLaunchdarklyConfigDirty> {}
export const RLaunchdarklyConfig = t.clean<LaunchdarklyConfigModel>(RLaunchdarklyConfigDirty as any);

/*
 * IO methods.
 */

export function parseLaunchdarklyConfig(src: any): LaunchdarklyConfigModel {
  return {
    clientSideId: src.client_side_id,
    isEnabled: src.enabled,
    userHash: src.user_hash || undefined,
    flags: (src.flags && pickBy(src.flags, isBoolean)) || undefined,
  };
}

/*
 * API type.
 */

export const LaunchdarklyConfigModel = makeApiType(
  'launchdarklyConfig',
  RLaunchdarklyConfig,
  parseLaunchdarklyConfig,
);
